import { render } from "./LoadingSpinnerSmall.vue?vue&type=template&id=3cbe875c&scoped=true&ts=true"
import script from "./LoadingSpinnerSmall.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinnerSmall.vue?vue&type=script&lang=ts"

import "./LoadingSpinnerSmall.vue?vue&type=style&index=0&id=3cbe875c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbe875c"]])

export default __exports__